<search-criteria
    [context]="context"
    [placeholder]="placeholder"
    (onResultsReceived)="receiveSearchCriteriaResults($event)"
    (onSearchStringUsed)="getSearchString($event)"
    (onSearchCompleted)="searchCompleted($event)">
</search-criteria>